<template>
  <div class="ub ub-ver fw list-query-header a-table">
    <a-form
      layout="inline"
      labelAlign="right"
      class="fw list-query-header-form"
      style="position: relative"
      :labelCol="{ style: 'width: ' + labelWidth + 'px' }"
    >
      <div
        class="ub form-item-div"
        :style="{
          width: collapsed ? listQueryFormWidth + 'px' : '100%',
          'flex-wrap': 'wrap',
        }"
        :class="collapsed ? 'collapsed' : ''"
      >
        <slot name="form" :appendToParent="collapsed ? 'append-to-table' : 'append-to-body'">
        </slot>
        <template v-if="!ifIsSignleRow">
          <a-form-item class="list-query-header-search absolute-form-item-bottom" v-if="!collapsed">
            <slot name="search">
              <Search
                :loading="loading"
                :collapsed="collapsed"
                :searchText="searchText"
                :resetText="resetText"
                v-model:showCollapsed="showCollapsed"
                @reset="reset"
                @search="search"
                @toggleFn="toggleFn"
              ></Search>
            </slot>
          </a-form-item>
        </template>
      </div>
      <template v-if="!ifIsSignleRow">
        <a-form-item
          v-if="collapsed"
          class="list-query-header-search absolute-form-item-top"
          style="margin-right: 0px !important"
        >
          <slot name="search">
            <Search
              :loading="loading"
              :searchText="searchText"
              :resetText="resetText"
              :collapsed="collapsed"
              v-model:showCollapsed="showCollapsed"
              @reset="reset"
              @search="search"
              @toggleFn="toggleFn"
            ></Search>
          </slot>
        </a-form-item>
      </template>
    </a-form>
    <div
      class="ub ub-pe fw"
      style="padding-bottom: 10px; box-sizing: border-box"
      v-if="ifIsSignleRow"
    >
      <slot name="search">
        <Search
          :loading="loading"
          :collapsed="collapsed"
          :searchText="searchText"
          :resetText="resetText"
          v-model:showCollapsed="showCollapsed"
          @reset="reset"
          @search="search"
          @toggleFn="toggleFn"
        ></Search>
      </slot>
    </div>
  </div>
</template>

<script lang="ts">
import {watch, defineComponent, onMounted, PropType, ref, onActivated, nextTick } from "vue";
import mixins from "@/core/mixins/table-height.mixins";
import Search from "./search.vue";
import { useWindowSize } from '@vueuse/core'
export default defineComponent({
  name: "ListQueryHeader",
  isGlobal: true,
  components: { Search },
  props: {
    labelWidth: {
      type: Number,
      default: 110,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searchText: {
      type: String,
      default: "查询",
    },
    resetText: {
      type: String,
      default: "重置",
    },
    formModel: {
      type: Object,
      default: () => {
        return {};
      },
    },
    search: {
      type: Function as PropType<Function>,
      default: () => {
        return () => {};
      },
    },
  },
  emits: ["reset", "setTableHeight"],
  setup(props, { emit }) {
    const { width, height } = useWindowSize();

    const {
      listQueryFormWidth,
      initQueryTableHeight,
      showCollapsed,
      ifIsSignleRow,
      calQueryWidth,
      tableHeight,
      toggle,
    } = mixins();
    watch(()=>width.value,(n,o)=>{
      // console.log(n,'---==-=-=-')
      toggle();
    })
    const collapsed = ref(true);
    onMounted(async () => {
      nextTick(async () => {
        await initQueryTableHeight();
        emit("setTableHeight", "");
      });
    });
    onActivated(async () => {
      nextTick(async () => {
        initQueryTableHeight();
        emit("setTableHeight", "");
      });
    });
    const reset = () => {
      emit("reset", "");
    };
    const search = () => {
      props.search();
    };
    const toggleFn = async () => {
      collapsed.value = !collapsed.value;
      nextTick(async () => {
        await toggle();
        emit("setTableHeight", "");
      });
    };
    return {
      reset,
      search,
      collapsed,
      listQueryFormWidth,
      showCollapsed,
      ifIsSignleRow,
      toggleFn,
      initQueryTableHeight,
    };
  },
});
</script>
<style lang="less" scoped>
.list-query-header {
  padding-top: 10px;
  box-sizing: border-box;
  margin-left: -10px;
}
.absolute-form-item-top {
  position: absolute;
  right: 0px;
  top: 0px;
}
.absolute-form-item-bottom {
  position: absolute;
  right: 0px;
  bottom: 0px;
}

.collapsed {
  height: 42px;
  overflow: hidden;
}
:deep(.ant-form-inline .list-query-header-search) {
  margin-right: 0 !important;
}
:deep(.ant-form-inline .ant-form-item) {
  margin-right: 0px !important;
}
:deep(.ant-form-item-label > label) {
  // margin-left: 14px;
}
/* /deep/ .ant-form-item:nth-of-type(1) .ant-form-item-label > label {
  margin-left: 0px;
} */

.form-item-div{
  padding-right: 160px;
}
</style>
